import { StatementUploadStatuses, StatementUploadStatusesResponse } from './useStatementUploadStatuses.interface';

import collectiveApi from 'modules/common/collectiveApi';

const PATH = 'bookkeeping/v2/bank-statements/upload-statuses/';

export default async function fetchStatementUploadStatuses(memberId: number): Promise<StatementUploadStatuses> {
    const { data } = await collectiveApi.get<StatementUploadStatusesResponse>(PATH, {
        params: { member_id: memberId },
    });
    // Unwrapped here rather than via `select`: `refetchInterval` receives the raw cached value, so a
    // projection applied at the observer would leave the poll schedule reading the envelope.
    //
    // Not defaulted. The field is required by the schema, and quietly substituting `{}` for a
    // malformed body would read as "nothing uploaded yet" — the hardest state in this flow to
    // notice, because it looks exactly like the legitimate empty case.
    return data.uploaded_statement_statuses;
}
